import createPusherEventHandlersForService from 'shared/clients/pusher/createPusherEventHandlersForService.js';
import { PIPELINES_SERVICE_KEY } from 'web/pipelines/pipelinesEnum';

export default createPusherEventHandlersForService(PIPELINES_SERVICE_KEY);
